// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from '../../messages';
import ErrorState from '../error-state/ErrorState';

function EmptyState() {
    return (
        <ErrorState>
            <FormattedMessage {...messages.noPosts} />
        </ErrorState>
    );
}
export default EmptyState;
